// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OpponentList__container-cb59a1 {
  --opponents-list-width: 220px;
  flex-shrink: 0;
  width: var(--opponents-list-width);
  overflow: hidden;
  padding-inline-start: 8px;
  overflow-y: auto;
  padding-bottom: 88px;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/SpeakerVideo/OpponentList/OpponentList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  --opponents-list-width: 220px;\n  flex-shrink: 0;\n  width: var(--opponents-list-width);\n  overflow: hidden;\n  padding-inline-start: 8px;\n  overflow-y: auto;\n  padding-bottom: 88px;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OpponentList__container-cb59a1`
};
module.exports = ___CSS_LOADER_EXPORT___;
